import { useState, useEffect, useContext, useMemo } from 'react'

import { EXPERIMENTS } from '@src/experiments'
import { ProductContext } from '@src/quince-site-common/src/contexts/product-context/product-context-provider.helper'
import Product from '@src/quince-site-common/src/domains/Product'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import { filterProductTags } from '@src/quince-site-pdp/src/templates/productPage/productPage.utils'
import { TPDPSectionData } from '@src/quince-site-pdp/src/types/pdp-section-data.type'
import { ProductSectionType } from '@src/quince-site-pdp/src/types/productPage.types'

import { getInitialSelectedOptionsForProduct } from '../../productPurchase/ProductPurchase'
import { getProductImagesSelectedOptions } from '../productImages.helper'

import { getColorProductMediaCombinations, getProductMedia } from './utils'

export const useProductImages = (product: Product, sectionData: TPDPSectionData) => {
  const initalSelectedOptionFromServer = useMemo(
    () => getInitialSelectedOptionsForProduct(product, sectionData),
    [product],
  )
  const selectedOptionsFromState = pdpStateManager.getSelectedOptions()
  const selectedOptions = getProductImagesSelectedOptions(initalSelectedOptionFromServer, selectedOptionsFromState)
  const { selectedVariantPurchaseInfo } = useContext(ProductContext)

  const productImageSectionData = sectionData[ProductSectionType.PRODUCT_IMAGES]

  const colorValueProductImagesMap = useMemo(() => getColorProductMediaCombinations(product), [product])

  const [productMedia, setProductMedia] = useState(productImageSectionData.productMedia)

  const expBucketUGC = useExperimentBucket(
    EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.experimentName,
    EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.bucketNames.variantA,
  )
  const isShowUGCVideoExp = expBucketUGC === EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.bucketNames.variantA

  const productTags = productHelper
    .getApplicableTags({
      product: product,
      selectedOptions,
    })
    .filter(productTag => filterProductTags(productTag, selectedVariantPurchaseInfo))

  useEffect(() => {
    setProductMedia(getProductMedia(product, selectedOptions))
  }, [selectedOptions])

  const directory = sectionData.directory
  const productMediaWithOrWithoutVideo = !isShowUGCVideoExp
    ? productMedia.filter(media => 'image' in media)
    : productMedia

  return {
    selectedOptions,
    colorValueProductImagesMap,
    productMedia: productMediaWithOrWithoutVideo,
    directory,
    productTags,
  }
}
